import { defineComponent as D, mergeModels as T, useModel as x, useTemplateRef as _, createElementBlock as k, openBlock as m, mergeProps as C, unref as o, createBlock as G, renderSlot as c, createCommentVNode as S, resolveDynamicComponent as B, withCtx as n, createElementVNode as i, normalizeClass as r, createVNode as l, createSlots as N, normalizeStyle as P, createTextVNode as s, toDisplayString as d } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer.js";
import { c_notification_drawer__group_toggle_title_max_lines as h } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_notification_drawer__group_toggle_title_max_lines.js";
import E from "../Tooltip/Tooltip.vue2.js";
import I from "../Badge.vue2.js";
import { useElementOverflow as $ } from "../../use/index.js";
import { AngleRightIcon as R } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { useOUIAProps as V } from "../../helpers/ouia.js";
const M = ["aria-expanded"], F = /* @__PURE__ */ D({
  name: "PfNotificationDrawerGroup",
  __name: "NotificationDrawerGroup",
  props: /* @__PURE__ */ T({
    count: {},
    read: { type: Boolean },
    onExpand: {},
    title: {},
    truncateTitle: { default: 0 },
    tooltipPosition: {},
    headingLevel: { default: "h1" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: ["update:expanded"],
  setup(u) {
    const p = u, g = V({ id: p.ouiaId, safe: p.ouiaSafe }), t = x(u, "expanded"), v = _("textRef"), y = $(v);
    function w(e) {
      (e.key === "Enter" || e.key === " ") && (e.preventDefault(), t.value = !t.value);
    }
    return (e, f) => (m(), k("section", C(o(g), {
      class: [o(a).notificationDrawerGroup, { [o(a).modifiers.expanded]: t.value }]
    }), [
      (m(), G(B(e.headingLevel), null, {
        default: n(() => [
          i("button", {
            class: r(o(a).notificationDrawerGroupToggle),
            "aria-expanded": t.value,
            onClick: f[0] || (f[0] = (O) => t.value = !t.value),
            onKeydown: w
          }, [
            l(E, { position: e.tooltipPosition }, N({
              default: n(() => [
                i("div", {
                  ref: "textRef",
                  class: r(o(a).notificationDrawerGroupToggleTitle),
                  tabindex: "0",
                  style: P(e.truncateTitle ? { [o(h).name]: e.truncateTitle.toString() } : void 0)
                }, [
                  c(e.$slots, "title", {}, () => [
                    s(d(e.title), 1)
                  ])
                ], 6)
              ]),
              _: 2
            }, [
              o(y) ? {
                name: "content",
                fn: n(() => [
                  s(d(e.title), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["position"]),
            i("div", {
              class: r(o(a).notificationDrawerGroupToggleCount)
            }, [
              l(I, { read: e.read }, {
                default: n(() => [
                  s(d(e.count), 1)
                ]),
                _: 1
              }, 8, ["read"])
            ], 2),
            i("span", {
              class: r(o(a).notificationDrawerGroupToggleIcon)
            }, [
              l(o(R))
            ], 2)
          ], 42, M)
        ]),
        _: 3
      })),
      t.value ? c(e.$slots, "default", { key: 0 }) : S("", !0)
    ], 16));
  }
});
export {
  F as default
};
